export default "__VITE_ASSET__d8e85829__"